import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedCustomer as setReduxSelectedCustomer } from "../../store/slices/customerSlice";
import CustomersList from "../../components/CustomersList";
import CustomerChatsList from "../../components/CustomerChatsList";
import AiChatContainer from "../../components/AiChatContainer";
import "./AiSupportChats.css";

const AiSupportChats = ({ children }) => {
    const dispatch = useDispatch();
    const selectedCustomer = useSelector(state => state.customer.selectedCustomer);
    const [selectedChat, setSelectedChat] = useState(null);

    const handleCustomerSelect = (customer) => {
        dispatch(setReduxSelectedCustomer(customer));
        
        // Автоматично вибираємо найактуальніший чат, якщо є чати
        if (customer.chats && customer.chats.length > 0) {
            // Сортуємо чати за датою оновлення (найновіший першим)
            const sortedChats = [...customer.chats].sort((a, b) => 
                new Date(b.updated_at) - new Date(a.updated_at)
            );
            setSelectedChat(sortedChats[0]);
        } else {
            setSelectedChat(null);
        }
    };

    const handleChatSelect = (chat) => {
        setSelectedChat(chat);
    };

    const handleChatUpdate = (updatedChat) => {
        // Оновлюємо поточний чат
        setSelectedChat(updatedChat);
        
        // Оновлюємо чат у списку чатів обраного користувача
        if (selectedCustomer) {
            const updatedCustomer = {
                ...selectedCustomer,
                chats: selectedCustomer.chats.map(chat => 
                    chat.id === updatedChat.id ? updatedChat : chat
                )
            };
            dispatch(setReduxSelectedCustomer(updatedCustomer));
        }
    };

    const handleRoleUpdate = (customerId, newRoleTitle) => {
        // Оновлюємо роль у поточному чаті, якщо він належить цьому користувачу
        if (selectedChat && selectedChat.customer && selectedChat.customer.customer_id === customerId) {
            setSelectedChat(prevChat => ({
                ...prevChat,
                customer: {
                    ...prevChat.customer,
                    role_title: newRoleTitle
                }
            }));
        }
    };

    return (
        <div className="ai-support-container">
            <div className="ai-chats-layout-new">
                <CustomersList 
                    onCustomerSelect={handleCustomerSelect}
                    activeCustomer={selectedCustomer}
                />
                <CustomerChatsList
                    customer={selectedCustomer}
                    onChatSelect={handleChatSelect}
                    activeChat={selectedChat}
                    onRoleUpdate={handleRoleUpdate}
                />
                <div className="ai-chat-content">
                    <AiChatContainer 
                        currentChat={selectedChat} 
                        onChatUpdate={handleChatUpdate}
                    />
                </div>
            </div>
            {children}
        </div>
    );
}

export default AiSupportChats;
